import { Button, Form, FormProps, Modal, ModalProps, message } from "antd";
import { ReactElement, ReactNode, cloneElement, useState } from "react";
import MESSAGES from "../../constants/messages";
import { useMineInfo } from "../../contexts/mine-info-context";

interface Props<T> extends Omit<FormProps, "onFinish"> {
  triggerPermission?: string;
  children: ReactNode;
  modalProps: ModalProps;
  trigger: ReactElement;
  okText: string;
  cancelText: string;
  onFinish: (values: T) => any;
}

const funcFallback = () => false;

function ViagsModalForm<T = any>({
  triggerPermission,
  modalProps,
  okText,
  cancelText,
  children,
  trigger,
  initialValues,
  onFinish = funcFallback,
  ...formProps
}: Partial<Props<T>>): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const { checkPermission } = useMineInfo();

  const finishHandler = async (values: T) => {
    setLoading(true);
    try {
      const res = await onFinish({ ...(initialValues ?? {}), ...values });
      if (res) setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  const handleClickTrigger = () => {
    if (triggerPermission && !checkPermission(triggerPermission)) return message.error(MESSAGES.NOT_PERMISSION);
    setOpen(true);
  };

  return (
    <>
      {trigger && cloneElement(trigger, { onClick: handleClickTrigger })}
      <Modal footer={null} open={open} onCancel={() => setOpen(false)} {...modalProps}>
        <Form className="h-100" initialValues={initialValues} onFinish={finishHandler} {...formProps}>
          <div className="d-flex flex-column h-100 w-100">
            <div className="flex-grow-1">{children}</div>
            <div className="d-flex justify-content-end" style={{ gap: 4 }}>
              <Button size="middle" onClick={() => setOpen(false)}>
                {cancelText ?? "Huỷ"}
              </Button>
              <Button loading={loading} htmlType="submit" size="middle" type="primary">
                {okText ?? "Xác nhận"}
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
}

export default ViagsModalForm;
